import { styled } from '@mui/material/styles';

import MuiDialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';

export const Dialog = styled(MuiDialog)(({ theme }) => ({ '& .MuiDialog-paper': { padding: theme.spacing(1) } }));

export const CloseModal = styled(IconButton)({ position: 'absolute', right: '2px', top: '2px' });
